export default __webpack_public_path__ + "static/media/IMG_9379.30841167.jpg";